<template>
  <Content
    class="verify-extend-membership"
    :title="$t('VERIFY_EXTEND_MEMBERSHIP.TITLE')"
  >
    <Card
      class="verify-extend-membership__card"
      :bordered="!isProcessing"
      :type="cardType"
    >
      <div :class="titleClasses">
        <i v-if="error" class="material-icons verify-extend-membership__icon">
          cancel
        </i>
        <i
          v-else-if="!isProcessing"
          class="material-icons verify-extend-membership__icon"
        >
          check_circle
        </i>
        <span>{{ title }}</span>
      </div>

      <div v-if="!isProcessing" class="verify-extend-membership__description">
        <span>{{ message }}</span>
        <span v-if="!error">
          (
          {{ $t('VERIFY_EXTEND_MEMBERSHIP.EXPIRE_DATE') }}:
          <span dir="ltr">{{ expireDate }}</span>
          )
        </span>

        <div class="verify-extend-membership__link">
          <router-link
            v-if="!isProcessing"
            :to="{ name: 'account-status' }"
            replace
          >
            {{ $t('VERIFY_EXTEND_MEMBERSHIP.BACK_LINK') }}
          </router-link>
        </div>
      </div>
    </Card>
  </Content>
</template>

<script>
import { MEMBERSHIP } from '@/store/types';
import Card from '@@/common/Card';
import { Membership } from '@/api/api';
import Content from '@@/common/layout/Content';
import { mapActions } from 'vuex';

export default {
  name: 'VerifyExtendMembership',

  components: {
    Card,
    Content,
  },

  data() {
    return {
      isProcessing: true,
      error: false,
      expireDate: '',
    };
  },

  computed: {
    paymentToken() {
      return this.$route.query.payment_token;
    },
    membershipInfo() {
      return this.$store.getters[MEMBERSHIP];
    },

    titleClasses() {
      return {
        'verify-extend-membership__title': true,
        'verify-extend-membership__title--error':
          !this.isProcessing && this.error,
        'verify-extend-membership__title--success': !(
          this.isProcessing || this.error
        ),
      };
    },

    cardType() {
      if (this.isProcessing) return '';
      return this.error ? 'danger' : 'success';
    },

    title() {
      if (this.isProcessing) {
        return this.$t('VERIFY_EXTEND_MEMBERSHIP.CHECKING');
      }
      return this.error
        ? this.$t('VERIFY_EXTEND_MEMBERSHIP.ERROR')
        : this.$t('VERIFY_EXTEND_MEMBERSHIP.SUCCESS');
    },
  },

  mounted() {
    if (this.paymentToken) {
      return Membership.verify({ payment_token: this.paymentToken })
        .then(
          ({
            body: {
              payment: { message, expire_date, status },
            },
          }) => {
            this.message = message;
            this.expireDate = expire_date;
            this.error = status !== 'success';
            if (status === 'success') {
              this.setMembershipInfo({
                ...this.membershipInfo,
                expireDate: expire_date,
                isExpired: false,
                canExtend: false,
              });
            }
          },
        )
        .catch(({ body: { message } }) => {
          this.error = true;
          if (message) this.message = message;
        })
        .finally(() => {
          this.isProcessing = false;
        });
    }
    this.redirectTo({ name: 'login' });
  },
  methods: {
    redirectTo(options) {
      this.$router.replace(options);
    },

    ...mapActions({
      setMembershipInfo: MEMBERSHIP,
    }),
  },
};
</script>

<style lang="scss">
.verify-extend-membership {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &__card {
    width: 80vw;
    max-width: rem-calc(500);
  }

  &__description {
    margin-top: $global-margin;
    margin-bottom: 0;
    margin-left: $global-margin;
    @include rtl() {
      margin-left: 0;
      margin-right: $global-margin;
    }
    font-size: rem-calc(13);
  }

  &__title--error {
    color: $lb-color-alert;
  }

  &__title--success {
    color: $lb-color-success;
  }

  &__link {
    margin-top: $global-margin;
    text-align: right;
    @include rtl() {
      text-align: left;
    }
  }
}
</style>
